import type { FC } from "react";

import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { DotsLoader } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

const LoaderContainer = styled(Box)`
    position: absolute;
    right: 0;
    bottom: 50%;
    transform: translateY(50%);
`;

export const SetupFieldLoader: FC = () => (
    <Box
        border={`1px solid ${colorsPalettes.carbon[100]}`}
        borderRadius="3px"
        height="100%"
    >
        <LoaderContainer>
            <DotsLoader />
        </LoaderContainer>
    </Box>
);
